import Nullstack from 'nullstack';
export default function IconDimensions({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-dimensions",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 5h11"
  }), "   ", Nullstack.element("path", {
    d: "M12 7l2 -2l-2 -2"
  }), "   ", Nullstack.element("path", {
    d: "M5 3l-2 2l2 2"
  }), "   ", Nullstack.element("path", {
    d: "M19 10v11"
  }), "   ", Nullstack.element("path", {
    d: "M17 19l2 2l2 -2"
  }), "   ", Nullstack.element("path", {
    d: "M21 12l-2 -2l-2 2"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "10",
    width: "11",
    height: "11",
    rx: "2"
  }), " ");
}